import { apiUrl } from './Config';
import {
  UPT_RESPONSE_AUTHORITY_CARRY_GRANTED_CODE,
  UPT_RESPONSE_NO_RECORD_RESPONSE_CODE,
  UPT_RESPONSE_VALID_PERMISSION_TRAVEL_CODE,
} from './AppConstants';
import { PASSENGER_LIST_TYPE_BOARDED, PASSENGER_LIST_TYPE_CHECKS } from './AppUrlConstants';

export const API_URL = apiUrl;

// Create account/register
export const REGISTER_ACCOUNT_ENDPOINT = `${apiUrl}/registration`;
export const REGISTER_CHECK_TOKEN_ENDPOINT = `${apiUrl}/check-token`;
export const REGISTER_RESEND_VERIFICATION_EMAIL_ENDPOINT = `${apiUrl}/resend-verification-email`;
export const PASSSWORD_RESET_ENDPOINT = `${apiUrl}/reset-password`;
export const SIGN_IN_ENDPOINT = `${apiUrl}/sign-in`;
export const SIGN_OUT_ENDPOINT = `${apiUrl}/sign-out`;
export const CHANGE_PASSWORD_ENDPOINT = `${apiUrl}/change-password`;

// Manager user
export const GROUP_ENDPOINT = `${apiUrl}/group`;
export const USER_ENDPOINT = `${apiUrl}/user`;

// Voyages (declarations)
export const VOYAGES_ENDPOINT = `${apiUrl}/declaration`;
export const CREATE_VOYAGE_ENDPOINT = VOYAGES_ENDPOINT; // same endpoint but POST method
export const ENDPOINT_DECLARATION_ATTACHMENTS_PATH = '/attachments';
export const ENDPOINT_DECLARATION_PATH = '/declaration';
export const ENDPOINT_FILE_UPLOAD_GENERAL_DECLARATION_PATH = '/upload-fal1';
export const ENDPOINT_FILE_UPLOAD_CREW_DETAILS_PATH = '/upload-fal5';
export const ENDPOINT_FILE_UPLOAD_PASSENGER_DETAILS_PATH = '/upload-fal6';
export const ENDPOINT_FILE_UPLOAD_SUPPORTING_DOCUMENTS_PATH = '/supporting';

// Get queue time

export const ENDPOINT_QUEUE_TIME = `${apiUrl}/service/get_queue_time`;

// Viewing people / UPT Status
const ENDPOINT_PEOPLE = '/people';
const QUERY_IS_TRAVELLING = 'is_travelling';
const QUERY_IS_CREW = 'is_crew';
export const ENDPOINT_PASSENGERS_PATH = `${ENDPOINT_PEOPLE}?${QUERY_IS_CREW}=False&${QUERY_IS_TRAVELLING}=True`;
export const ENDPOINT_PAX_DOWNLOAD_PATH = 'passengers/download';

// Declaration Query Params
export const DECLARATION_STATUSCOUNT_PART = 'status_count=True';
export const AWS_URL = 'presigned-url';

// People Query Params
export const UPT_STATUS_PART = 'response_sector';
export const UPT_SEARCH_PART = 'search';
export const UPT_RESPONSE_CODES = 'response_codes';
/* 1-based, unlike the voyages list's 0-based page_start. Omitting it turns off pagination and, less
   obviously, the isGBR filter with it - the API nests that filter inside `if current_page:`. */
export const UPT_CURRENT_PAGE = 'current_page';
export const UPT_PER_PAGE = 'per_page';

export const UPT_IS_GBR = 'isGBR';

/* An action group is not an API concept: it is a set of response codes, with isGBR splitting 0Z on
   nationality. isGBR is sent even when false - the download endpoint guards on `is_gbr is not None`
   and skips the nationality filter entirely if the parameter is absent. */
export const UPT_PASSENGER_LIST_QUERY = {
  [PASSENGER_LIST_TYPE_BOARDED]: {
    responseCodes: [UPT_RESPONSE_VALID_PERMISSION_TRAVEL_CODE, UPT_RESPONSE_AUTHORITY_CARRY_GRANTED_CODE],
    isGBR: true,
  },
  [PASSENGER_LIST_TYPE_CHECKS]: {
    responseCodes: [UPT_RESPONSE_NO_RECORD_RESPONSE_CODE, UPT_RESPONSE_AUTHORITY_CARRY_GRANTED_CODE],
    isGBR: false,
  },
};

// Responses
export const DUPLICATE_RECORDS = 'Duplicate person records found. Please check the upload (note that duplication could be across FAL5 and 6).';
export const FILE_MISSING = 'No file provided';
export const FIELD_REQUIRED_ERROR = 'field required';
export const FILE_TOO_LARGE = 'Large file';
export const FILE_TYPE_INVALID_PREFIX = 'Invalid file type';
export const FILE_TYPE_INVALID_CSV_XLSX = "Invalid file type: Not a ['csv', 'xlsx']";
export const FAL1_WRONG_TEMPLATE = "This file does not contain a worksheet tab named 'FAL 1'. Please check you are using the latest version of the FAL 1 template.";
export const FAL5_IS_EMPTY = 'File has no crew data';
export const FAL6_IS_EMPTY = 'No data rows found in file.';
export const TOKEN_INVALID = 'Token is invalid or it has expired';
export const TOKEN_USED_TO_REGISTER = 'Token was already used';
export const USER_ALREADY_REGISTERED = 'User is already registered';
export const USER_ALREADY_VERIFIED = 'User already verified';
export const USER_ALREADY_VERIFIED_LOGIN = 'User already verified, please login';
export const USER_AWAITING_VERIFICATION = 'User is awaiting verification';
export const USER_NOT_REGISTERED = 'User is not registered';
export const USER_HAS_NOT_BEEN_VERIFIED = 'User has not been verified yet';
export const USER_NOT_VERIFIED = 'User not verified, please verify registration';
export const USER_SIGN_IN_DETAILS_INVALID = 'Email or password invalid';
export const USER_MUST_UPDATE_PASSWORD = 'To use this service you will need to create a new password';
export const USER_CURRENT_PASSWORD_INCORRECT = 'current password is incorrect';
export const USER_EXPIRED_AUTH_TOKEN = 'Authentication token has expired. Please obtain a new token and try again.';
export const USER_PASSWORD_BELOW_MIN_LEN = 'ensure this value has at least 10 characters';
export const INVALID_FAL_NAME = 'Invalid file name';
